// Buying options
document.addEventListener("DOMContentLoaded", () => {
  const allBuyingContainers = document.querySelectorAll(
    ".selector__buying-container"
  );
  allBuyingContainers.forEach((container) => {
    const buyingOptionItems = container.querySelectorAll(
      ".selector__buying-option"
    );
    buyingOptionItems.forEach((option) => {
      option.addEventListener("click", () => {
        buyingOptionItems.forEach((opt) => opt.classList.remove("active"));
        option.classList.add("active");
      });
    });
  });
});

// Tab buttons and color management
document.addEventListener("DOMContentLoaded", () => {
  const allTabButtons = document.querySelectorAll(".selector__tab-button");
  const allSections = document.querySelectorAll(
    ".product-selector__color-changer"
  );

  window.currentSelectedType = "screw-in";

  const activeTab =
    document.querySelector(".selector__tab-button.active") || allTabButtons[0];
  if (activeTab) {
    window.currentSelectedType = activeTab.dataset.type;
    applyColors(activeTab.dataset);
    updateProductVariant(activeTab.dataset.type);
  }

  allTabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      window.currentSelectedType = button.dataset.type;
      applyColors(button.dataset);

      const currentCard = button.closest(
        ".selector__product-card, .unified-slide__card"
      );
      if (currentCard) {
        const currentCardTabButtons = currentCard.querySelectorAll(
          ".selector__tab-button"
        );
        currentCardTabButtons.forEach((btn) => {
          btn.classList.toggle(
            "active",
            btn.dataset.type === button.dataset.type
          );
        });
      }

      updateProductVariant(button.dataset.type, button);
    });
  });

  function applyColors(dataset) {
    allSections.forEach((section) => {
      section.style.setProperty("--color-120", dataset["color-120"]);
      section.style.setProperty("--color-110", dataset["color-110"]);
      section.style.setProperty("--color-100", dataset["color-100"]);
      section.style.setProperty("--color-70", dataset["color-70"]);
      section.style.setProperty("--color-40", dataset["color-40"]);
      section.style.setProperty("--color-30", dataset["color-30"]);
      section.style.setProperty("--color-20", dataset["color-20"]);
      section.style.setProperty("--color-5", dataset["color-5"]);
      section.style.setProperty("--color-radial", dataset["colorRadial"]);
    });
  }

  function updateProductVariant(type, button = null, card = null) {
    const activeCard = card || (button ? button.closest(
      ".selector__product-card.active, .unified-slide.active .unified-slide__card"
    ) : document.querySelector(
      ".selector__product-card.active, .unified-slide.active .unified-slide__card"
    ));
    if (!activeCard) return;

    const productTypesContainer = activeCard.querySelector(
      ".tabs-container.selector__product-types"
    );
    if (!productTypesContainer) return;

    let variantId;
    if (type === "screw-in") {
      variantId = productTypesContainer.dataset.screwInVariant;
    } else if (type === "snap-in") {
      variantId = productTypesContainer.dataset.snapInVariant;
    }

    if (!variantId) return;

    const addToCartButton = activeCard.querySelector("add-to-cart");
    if (addToCartButton) {
      addToCartButton.setAttribute("data-variant-id", variantId);
      addToCartButton.setAttribute("data-current-type", type);
    }

    // Update featured image based on variant type
    updateFeaturedImage(type, productTypesContainer);
  }

  function updateFeaturedImage(type, productTypesContainer) {
    console.log("updateFeaturedImage called with type:", type);

    if (!productTypesContainer) {
      console.log("productTypesContainer is null");
      return;
    }

    const currentCard = productTypesContainer.closest(
      ".selector__product-card, .unified-slide__card"
    );
    if (!currentCard) {
      console.log("currentCard not found");
      return;
    }

    // Get the featured image based on variant type
    let featuredImageUrl = null;

    if (type === "snap-in") {
      const snapInProduct = productTypesContainer.dataset.snapInProduct;
      console.log("Snap-in product handle:", snapInProduct);
      if (snapInProduct) {
        // Try to fetch the snap-in product's featured image from the data attribute
        featuredImageUrl = productTypesContainer.dataset.snapInFeaturedImage;
        console.log("Snap-in featured image URL:", featuredImageUrl);
      }
    } else if (type === "screw-in") {
      featuredImageUrl = productTypesContainer.dataset.screwInFeaturedImage;
      console.log("Screw-in featured image URL:", featuredImageUrl);
    }

    console.log("Final featured image URL:", featuredImageUrl);

    if (featuredImageUrl) {
      // For mobile: find the parent unified-slide and update its image
      const unifiedSlide = currentCard.closest(".unified-slide");
      if (unifiedSlide) {
        const mobileImage = unifiedSlide.querySelector(".unified-slide__image picture img");
        console.log("Mobile image element found:", !!mobileImage);
        if (mobileImage) {
          console.log("Setting mobile image src to:", featuredImageUrl);
          mobileImage.src = featuredImageUrl;
        }
      }

      // For desktop: find the corresponding image in the ProductImageSlider
      const productCard = currentCard.closest(".selector__product-card");
      if (productCard) {
        const allCards = Array.from(document.querySelectorAll(".selector__product-card"));
        const cardIndex = allCards.indexOf(productCard);
        console.log("Desktop card index:", cardIndex);

        if (cardIndex >= 0) {
          const imageSlider = document.querySelector("#ProductImageSlider");
          console.log("Image slider found:", !!imageSlider);
          if (imageSlider) {
            const allPictures = imageSlider.querySelectorAll("picture");
            console.log("Total pictures in slider:", allPictures.length);
            if (cardIndex < allPictures.length) {
              const picture = allPictures[cardIndex];
              const img = picture.querySelector("img");
              console.log("Desktop image element found:", !!img);
              if (img) {
                console.log("Setting desktop image src to:", featuredImageUrl);
                img.src = featuredImageUrl;
              }
            }
          }
        }
      }
    } else {
      console.log("No featured image URL found for type:", type);
    }
  }

  window.updateProductVariant = updateProductVariant;
  window.applyColors = applyColors;
});

// Main slider logic
document.addEventListener("DOMContentLoaded", () => {
  const isMobile = () => window.innerWidth <= 768;

  // MOBILE: Unified slider
  const unifiedSlider = document.querySelector(".unified-slider-wrapper");
  const mobileNextBtn = document.getElementById("SelectorNextButtonMobile");
  const mobilePrevBtn = document.getElementById("SelectorPrevButtonMobile");

  // DESKTOP: Separate sliders
  const productCardSlider = document.getElementById("ProductCardSlider");
  const imageSlider = document.getElementById("ProductImageSlider");
  const desktopNextBtn = document.getElementById("SelectorNextButton");
  const desktopPrevBtn = document.getElementById("SelectorPrevButton");

  let currentIndex = 1;
  let isTransitioning = false;

  // Initialize based on viewport
  function init() {
    if (isMobile()) {
      initMobile();
    } else {
      initDesktop();
    }
  }

  // MOBILE INITIALIZATION
  function initMobile() {
    if (!unifiedSlider) return;

    const allSlides = Array.from(document.querySelectorAll(".unified-slide"));
    const realSlideCount = allSlides.length;

    // Clone first and last for infinite scroll
    if (!unifiedSlider.querySelector(".unified-slide[data-cloned]")) {
      const firstClone = allSlides[0].cloneNode(true);
      const lastClone = allSlides[realSlideCount - 1].cloneNode(true);
      firstClone.setAttribute("data-cloned", "true");
      lastClone.setAttribute("data-cloned", "true");
      firstClone.classList.remove("active");
      lastClone.classList.remove("active");

      unifiedSlider.appendChild(firstClone);
      unifiedSlider.insertBefore(lastClone, allSlides[0]);
    }

    const slideWidth = unifiedSlider.offsetWidth;
    unifiedSlider.scrollLeft = slideWidth;

    updateMobileActiveSlide(currentIndex);
  }

  function updateMobileActiveSlide(index) {
    const allSlides = Array.from(document.querySelectorAll(".unified-slide"));
    allSlides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add("active");
        applyPreservedState(slide);
      } else {
        slide.classList.remove("active");
      }
    });
    // Clear any stuck active/focus states
    blurAllInteractiveElements();
  }

  function scrollMobileTo(index, animated = true) {
    if (!unifiedSlider) return;
    const slideWidth = unifiedSlider.offsetWidth;
    unifiedSlider.scrollTo({
      left: index * slideWidth,
      behavior: animated ? "smooth" : "auto",
    });
  }

  function handleMobileNext() {
    if (isTransitioning) return;
    const allSlides = Array.from(document.querySelectorAll(".unified-slide"));
    currentIndex++;
    scrollMobileTo(currentIndex);
    updateMobileActiveSlide(currentIndex);

    if (currentIndex === allSlides.length - 1) {
      isTransitioning = true;
      setTimeout(() => {
        currentIndex = 1;
        scrollMobileTo(currentIndex, false);
        updateMobileActiveSlide(currentIndex);
        isTransitioning = false;
      }, 600);
    }
  }

  function handleMobilePrev() {
    if (isTransitioning) return;
    const allSlides = Array.from(document.querySelectorAll(".unified-slide"));
    currentIndex--;
    scrollMobileTo(currentIndex);
    updateMobileActiveSlide(currentIndex);

    if (currentIndex === 0) {
      isTransitioning = true;
      setTimeout(() => {
        currentIndex = allSlides.length - 2;
        scrollMobileTo(currentIndex, false);
        updateMobileActiveSlide(currentIndex);
        isTransitioning = false;
      }, 600);
    }
  }

  // Touch/swipe for mobile
  if (unifiedSlider) {
    let touchStartX = 0;
    let touchStartY = 0;
    const minSwipeDistance = 50;

    unifiedSlider.addEventListener(
      "touchstart",
      (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: false }
    );

    unifiedSlider.addEventListener(
      "touchmove",
      (e) => {
        if (!touchStartX) return;
        const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
        const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
        if (deltaX > deltaY && deltaX > 10) {
          e.preventDefault();
        }
      },
      { passive: false }
    );

    unifiedSlider.addEventListener(
      "touchend",
      (e) => {
        if (!touchStartX || isTransitioning) return;
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;
        const deltaX = touchStartX - touchEndX;
        const deltaY = Math.abs(touchStartY - touchEndY);

        if (Math.abs(deltaX) > minSwipeDistance && Math.abs(deltaX) > deltaY) {
          if (deltaX > 0) {
            handleMobileNext();
          } else {
            handleMobilePrev();
          }
        }

        touchStartX = 0;
        touchStartY = 0;
      },
      { passive: true }
    );
  }

  // DESKTOP INITIALIZATION
  function initDesktop() {
    if (!productCardSlider || !imageSlider) return;

    let productCards = document.querySelectorAll(".selector__product-card");
    let productImages = imageSlider.querySelectorAll("picture");
    const realSlideCount = productCards.length;

    // Clone for infinite scroll
    if (
      !productCardSlider.querySelector(".selector__product-card[data-cloned]")
    ) {
      const firstCard = productCards[0].cloneNode(true);
      firstCard.classList.remove("active");
      firstCard.setAttribute("data-cloned", "true");
      productCardSlider.appendChild(firstCard);
      productCardSlider.insertBefore(
        productCards[realSlideCount - 1].cloneNode(true),
        productCards[0]
      );

      imageSlider.appendChild(productImages[0].cloneNode(true));
      imageSlider.insertBefore(
        productImages[productImages.length - 1].cloneNode(true),
        productImages[0]
      );
    }

    productCards = document.querySelectorAll(".selector__product-card");
    productImages = imageSlider.querySelectorAll("picture");
    const allCards = Array.from(productCards);
    const allImages = Array.from(productImages);

    const imageWidth = imageSlider.offsetWidth + 24;
    imageSlider.scrollLeft = imageWidth;

    productCardSlider.classList.add(
      "selector__product-card-wrapper--positioned"
    );

    allCards.forEach((card, i) => {
      card.classList.add("selector__product-card--positioned");
      if (i === currentIndex) {
        card.classList.add("selector__product-card--active");
        card.classList.remove("selector__product-card--inactive");
        card.classList.add("active");
        productCardSlider.style.height = card.offsetHeight + "px";
      } else {
        card.classList.add("selector__product-card--inactive");
        card.classList.remove("selector__product-card--active");
        card.classList.remove("active");
      }
    });

    allImages.forEach((img, i) => {
      if (i === currentIndex) {
        img.style.opacity = "1";
        img.classList.add("active");
      } else {
        img.style.opacity = "0";
        img.classList.remove("active");
      }
    });

    applyPreservedState(allCards[currentIndex]);
  }

  function updateDesktopActiveClass(index) {
    const allCards = Array.from(
      document.querySelectorAll(".selector__product-card")
    );
    const allImages = Array.from(imageSlider.querySelectorAll("picture"));

    allCards.forEach((card, i) => {
      if (i === index) {
        card.classList.add("selector__product-card--active", "active");
        card.classList.remove("selector__product-card--inactive");
        productCardSlider.style.height = card.offsetHeight + "px";
        applyPreservedState(card);
      } else {
        card.classList.add("selector__product-card--inactive");
        card.classList.remove("selector__product-card--active", "active");
      }
    });

    allImages.forEach((img, i) => {
      img.style.transition = "opacity 0.3s ease-in-out";
      if (i === index) {
        img.style.opacity = "1";
        img.classList.add("active");
      } else {
        img.style.opacity = "0";
        img.classList.remove("active");
      }
    });

    // Clear any stuck active/focus states
    blurAllInteractiveElements();
  }

  function scrollDesktopTo(index, animated = true) {
    const imageWidth = imageSlider.offsetWidth + 24;
    imageSlider.scrollTo({
      left: index * imageWidth,
      behavior: animated ? "smooth" : "auto",
    });
  }

  function handleDesktopNext() {
    if (isTransitioning) return;
    const allCards = Array.from(
      document.querySelectorAll(".selector__product-card")
    );
    currentIndex++;
    scrollDesktopTo(currentIndex);
    updateDesktopActiveClass(currentIndex);

    if (currentIndex === allCards.length - 1) {
      isTransitioning = true;
      setTimeout(() => {
        currentIndex = 1;
        scrollDesktopTo(currentIndex, false);
        updateDesktopActiveClass(currentIndex);
        isTransitioning = false;
      }, 600);
    }
  }

  function handleDesktopPrev() {
    if (isTransitioning) return;
    const allCards = Array.from(
      document.querySelectorAll(".selector__product-card")
    );
    currentIndex--;
    scrollDesktopTo(currentIndex);
    updateDesktopActiveClass(currentIndex);

    if (currentIndex === 0) {
      isTransitioning = true;
      setTimeout(() => {
        currentIndex = allCards.length - 2;
        scrollDesktopTo(currentIndex, false);
        updateDesktopActiveClass(currentIndex);
        isTransitioning = false;
      }, 600);
    }
  }

  // Apply preserved state to active slide/card
  function applyPreservedState(element) {
    const card = element.classList.contains("unified-slide")
      ? element.querySelector(".unified-slide__card")
      : element;

    if (!card) return;

    const tabButtons = card.querySelectorAll(".selector__tab-button");
    const targetTab = Array.from(tabButtons).find(
      (btn) => btn.dataset.type === window.currentSelectedType
    );

    if (targetTab) {
      tabButtons.forEach((btn) => {
        btn.classList.toggle(
          "active",
          btn.dataset.type === window.currentSelectedType
        );
      });
      window.applyColors(targetTab.dataset);
      window.updateProductVariant(window.currentSelectedType, null, card);
    } else {
      const firstAvailableTab = tabButtons[0];
      if (firstAvailableTab) {
        window.currentSelectedType = firstAvailableTab.dataset.type;
        tabButtons.forEach((btn) => {
          btn.classList.toggle("active", btn === firstAvailableTab);
        });
        window.applyColors(firstAvailableTab.dataset);
        window.updateProductVariant(window.currentSelectedType, null, card);
      }
    }
  }

  // Clear stuck active/focus states on all interactive elements
  function blurAllInteractiveElements() {
    // Blur all tab buttons
    document
      .querySelectorAll(".selector__tab-button")
      .forEach((btn) => btn.blur());
    // Blur all quantity buttons
    document.querySelectorAll(".quantity__button").forEach((btn) => btn.blur());
    // Blur all add-to-cart buttons
    document
      .querySelectorAll(".selector__add-to-cart")
      .forEach((btn) => btn.blur());
    // Blur buying options
    document
      .querySelectorAll(".selector__buying-option")
      .forEach((btn) => btn.blur());
  }

  // Attach event listeners
  if (mobileNextBtn) mobileNextBtn.addEventListener("click", handleMobileNext);
  if (mobilePrevBtn) mobilePrevBtn.addEventListener("click", handleMobilePrev);
  if (desktopNextBtn)
    desktopNextBtn.addEventListener("click", handleDesktopNext);
  if (desktopPrevBtn)
    desktopPrevBtn.addEventListener("click", handleDesktopPrev);

  // Initialize
  init();

  // Handle resize
  window.addEventListener("resize", () => {
    const wasMobile = document.body.classList.contains("mobile-view");
    const nowMobile = isMobile();

    if (wasMobile !== nowMobile) {
      currentIndex = 1;
      isTransitioning = false;
      init();
    }

    document.body.classList.toggle("mobile-view", nowMobile);
  });

  // Set initial class
  document.body.classList.toggle("mobile-view", isMobile());
});
